// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared look of the form popups (votings): fixed header with title and close button,
 * scrolling body, fixed footer with the actions. Opened with cssClass "form-modal", so on
 * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).
 * Loaded with @use by each popup stylesheet. */
:host {
  justify-content: flex-start;
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-header__text {
  min-width: 0;
}
.popup-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.popup-header__subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin-top: 4px;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
}

.popup-close {
  display: grid;
  place-items: center;
  align-self: flex-start;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.popup-close ion-icon {
  display: block;
  font-size: 21px;
}
.popup-close:hover, .popup-close:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}

.popup-body {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-footer ion-button {
  margin: 0;
  min-width: 110px;
  height: 42px;
  --border-radius: 10px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}
@media (max-width: 575px) {
  .popup-footer ion-button {
    flex: 1;
  }
}

/* Section with a small uppercase title */
.popup-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popup-section__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--ion-color-medium-shade);
}
.popup-section__title ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}

/* Field: label above a bordered input */
.popup-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.popup-field__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ion-color-step-750, #404040);
}

.popup-input,
.popup-textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.popup-input::placeholder,
.popup-textarea::placeholder {
  color: var(--ion-color-medium);
}
.popup-input:focus,
.popup-textarea:focus {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);
}

.popup-input {
  height: 48px;
  padding-top: 0;
  padding-bottom: 0;
}

.popup-textarea {
  min-height: 96px;
  line-height: 1.5;
  resize: vertical;
}

/* File row (attachments): icon, name (download), actions */
.file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 8px 8px 12px;
  border-radius: 10px;
  background: rgba(var(--ion-color-medium-rgb), 0.07);
}
.file-row > ion-icon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-primary);
}
.file-row__name {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-row button.file-row__name {
  cursor: pointer;
}
.file-row button.file-row__name:hover, .file-row button.file-row__name:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  text-decoration: underline;
}

/* Small round icon button (remove, download) */
.icon-button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.icon-button ion-icon {
  font-size: 18px;
}
.icon-button:hover, .icon-button:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.icon-button--danger:hover, .icon-button--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}

.popup-body {
  padding: 16px 20px;
}

/* Options: stacked soft action buttons derived from the brand primary. */
.pso-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pso-option {
  width: 100%;
  min-height: 46px;
  padding: 12px 14px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.14);
  border-radius: 10px;
  background: rgba(var(--ion-color-primary-rgb), 0.06);
  color: var(--ion-color-primary);
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-align: center;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}
.pso-option:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(var(--ion-color-primary-rgb), 0.16);
}
.pso-option:active {
  transform: translateY(0);
  box-shadow: none;
}
.pso-option:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.25);
}
.pso-option {
  /* Offline/limited connection: mirror the toolbar's "medium" colour cue. */
}
.pso-option--offline {
  border-color: rgba(var(--ion-color-medium-rgb), 0.3);
  background: rgba(var(--ion-color-medium-rgb), 0.08);
  color: var(--ion-color-medium);
}
.pso-option--offline:hover {
  background: rgba(var(--ion-color-medium-rgb), 0.14);
  box-shadow: 0 6px 16px rgba(var(--ion-color-medium-rgb), 0.16);
}

@media (prefers-reduced-motion: reduce) {
  .pso-option {
    transition: none;
  }
  .pso-option:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_popup-form.scss","webpack://./src/components/popup/popup-select-operation/popup-select-operation.component.scss"],"names":[],"mappings":"AAAA;;;+CAAA;AAKA;EACE,2BAAA;EACA,4CAAA;EACA,6CAAA;ACAF;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kEAAA;EACA,gEAAA;ACAF;ADEE;EACE,YAAA;ACAJ;ADGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACDJ;ADIE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;ACFJ;;ADMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;ACHF;ADKE;EACE,cAAA;EACA,eAAA;ACHJ;ADME;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ACLJ;;ADSA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACNF;;ADSA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;EACA,gEAAA;EACA,6DAAA;ACNF;ADQE;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ACNJ;ADSE;EACE;IACE,OAAA;ECPJ;AACF;;ADWA,yCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACRF;ADUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;ACRJ;ADUI;EACE,eAAA;EACA,+BAAA;ACRN;;ADaA,wCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ACVF;ADYE;EACE,eAAA;EACA,gBAAA;EACA,yCAAA;ACVJ;;ADcA;;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6CAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;ACXF;ADaE;;EACE,8BAAA;ACVJ;ADaE;;EACE,sCAAA;EACA,8DAAA;ACVJ;;ADcA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;ACXF;;ADcA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;ACXF;;ADcA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;ACXF;ADaE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ACXJ;ADcE;EACE,OAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACZJ;ADeE;EACE,eAAA;ACbJ;ADeI;EAEE,aAAA;EACA,+BAAA;EACA,0BAAA;ACdN;;ADmBA,+CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AChBF;ADkBE;EACE,eAAA;AChBJ;ADmBE;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;AClBJ;ADqBE;EAEE,8BAAA;EACA,kDAAA;ACpBJ;;AArOA;EACE,kBAAA;AAwOF;;AArOA,yEAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAwOF;;AArOA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0DAAA;EACA,mBAAA;EACA,oDAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,8EAAA;AAwOF;AAtOE;EACE,oDAAA;EACA,2BAAA;EACA,+DAAA;AAwOJ;AArOE;EACE,wBAAA;EACA,gBAAA;AAuOJ;AApOE;EACE,aAAA;EACA,8DAAA;AAsOJ;AAnQA;EAgCE,0EAAA;AAsOF;AArOE;EACE,oDAAA;EACA,mDAAA;EACA,8BAAA;AAuOJ;AArOI;EACE,mDAAA;EACA,8DAAA;AAuON;;AAlOA;EACE;IACE,gBAAA;EAqOF;EAnOE;IACE,eAAA;EAqOJ;AACF","sourcesContent":["/* Shared look of the form popups (votings): fixed header with title and close button,\n * scrolling body, fixed footer with the actions. Opened with cssClass \"form-modal\", so on\n * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).\n * Loaded with @use by each popup stylesheet. */\n\n:host {\n  justify-content: flex-start;\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  &__text {\n    min-width: 0;\n  }\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n  }\n\n  &__subtitle {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 10px;\n    margin-top: 4px;\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n  }\n}\n\n.popup-close {\n  display: grid;\n  place-items: center;\n  align-self: flex-start;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 21px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n}\n\n.popup-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n\n.popup-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  ion-button {\n    margin: 0;\n    min-width: 110px;\n    height: 42px;\n    --border-radius: 10px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n\n  @media (max-width: 575px) {\n    ion-button {\n      flex: 1;\n    }\n  }\n}\n\n/* Section with a small uppercase title */\n.popup-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      font-size: 16px;\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n/* Field: label above a bordered input */\n.popup-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n\n  &__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--ion-color-step-750, #404040);\n  }\n}\n\n.popup-input,\n.popup-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &::placeholder {\n    color: var(--ion-color-medium);\n  }\n\n  &:focus {\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n  }\n}\n\n.popup-input {\n  height: 48px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.popup-textarea {\n  min-height: 96px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n/* File row (attachments): icon, name (download), actions */\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 8px 8px 8px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-medium-rgb), 0.07);\n\n  > ion-icon {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n\n  &__name {\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 14px;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  button.file-row__name {\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      outline: none;\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n\n/* Small round icon button (remove, download) */\n.icon-button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  ion-icon {\n    font-size: 18px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n\n  &--danger:hover,\n  &--danger:focus-visible {\n    color: var(--ion-color-danger);\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n  }\n}\n","@use \"../../../theme/popup-form\";\n\n.popup-body {\n  padding: 16px 20px;\n}\n\n/* Options: stacked soft action buttons derived from the brand primary. */\n.pso-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pso-option {\n  width: 100%;\n  min-height: 46px;\n  padding: 12px 14px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.14);\n  border-radius: 10px;\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n  color: var(--ion-color-primary);\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  text-align: center;\n  cursor: pointer;\n  transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n\n  &:hover {\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(var(--ion-color-primary-rgb), 0.16);\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.25);\n  }\n\n  /* Offline/limited connection: mirror the toolbar's \"medium\" colour cue. */\n  &--offline {\n    border-color: rgba(var(--ion-color-medium-rgb), 0.3);\n    background: rgba(var(--ion-color-medium-rgb), 0.08);\n    color: var(--ion-color-medium);\n\n    &:hover {\n      background: rgba(var(--ion-color-medium-rgb), 0.14);\n      box-shadow: 0 6px 16px rgba(var(--ion-color-medium-rgb), 0.16);\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pso-option {\n    transition: none;\n\n    &:hover {\n      transform: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
